import React, { Component, PropTypes } from 'react';
import {
  RaisedButton,
  List,
  ListItem,
  IconButton,
  Checkbox
} from 'material-ui';
import Loader from 'components/Material/Loader';
import Message from 'services/Message';
import * as SvgIcons from 'components/Material/SvgIcons';
let { ContentClear, ContentSend, MapsBeenhere } = SvgIcons;

export default class InvitationOverview extends Component {
  static propTypes = {
    list: PropTypes.array,
    prevDisabled: PropTypes.bool,
    nextDisabled: PropTypes.bool,
    loading: PropTypes.bool,
    prev: PropTypes.func,
    next: PropTypes.func
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  constructor() {
    super(...arguments);
    this.state = {
      collapsed: false,
      clicked: false,
      count: 0
    };
  }

  select(item) {
    if (this.props.onSelect) {
      this.props.onSelect(item);
    }
  }

  toggle() {
    this.setState({ collapsed: !this.state.collapsed });
  }

  onTouchTapRightIcon(item) {
    if (this.props.onTouchTapRightIcon) {
      this.props.onTouchTapRightIcon(item);
    }
  }

  onTouchTapLeftIcon(item) {
    if (this.props.onTouchTapLeftIcon) {
      this.props.onTouchTapLeftIcon(item);
    }
  }

  onCheck(item) {
    if (this.props.onCheck) {
      this.props.onCheck(item);
    }
  }

  render() {
    const {
      list,
      prevDisabled,
      nextDisabled,
      prev,
      next,
      loading,
      total,
      pageStartInvitations,
      pageLengthInvitations
    } = this.props;

    if (pageStartInvitations == 0 && total < pageLengthInvitations) {
      this.state.count = total;
    } else {
      this.state.count = list.length + pageStartInvitations;
    }

    let finTotal, buttons;
    if (total < pageLengthInvitations) {
      finTotal = '';
      buttons = null;
    } else {
      finTotal = '/' + total;
      buttons = (
        <div>
          {loading && <Loader />}
          <RaisedButton
            label={'prev'}
            disabled={prevDisabled}
            onTouchTap={prev}
          />
          <RaisedButton
            label={'next'}
            disabled={
              pageStartInvitations + pageLengthInvitations > total
                ? true
                : false
            }
            onTouchTap={next}
          />
        </div>
      );
    }

    return (
      <List
        subheader={'Invitations (' + this.state.count + finTotal + ')'}
        style={{ marginTop: '10px', backgroundColor: '#FFFFFF' }}
        subheaderStyle={{
          fontSize: 24,
          borderStyle: 'none none solid none',
          borderWidth: '1px',
          borderColor: 'rgba(0, 0, 0, 0.12)'
        }}
      >
        {list.map(item => {
          let expiration, resendButton, checkBoxItem;
          if (item.expires) {
            expiration = ' (' + item.expires.slice(0, 10) + ')';
            if (!item.clicked) {
              resendButton = (
                <IconButton
                  style={{ marginLeft: 30 }}
                  onTouchTap={this.onTouchTapLeftIcon.bind(this, item)}
                  tooltip={this.context.getIntlMessage('invitation.resend')}
                  tooltipPosition="top-right"
                >
                  <ContentSend />
                </IconButton>
              );
            } else {
              resendButton = (
                <IconButton
                  style={{ marginLeft: 30 }}
                  onTouchTap={this.onTouchTapLeftIcon.bind(this, item)}
                  tooltip={this.context.getIntlMessage('invitation.resend')}
                  tooltipPosition="top-right"
                >
                  <MapsBeenhere />
                </IconButton>
              );
            }

            checkBoxItem = <Checkbox onCheck={this.onCheck.bind(this, item)} />;
          } else {
            expiration = '';
            resendButton = null;
          }
          return (
            <ListItem
              key={item.id}
              primaryText={item.email + expiration}
              leftCheckbox={checkBoxItem}
              onTouchTap={this.select.bind(this, item)}
              rightIconButton={
                <IconButton
                  onTouchTap={this.onTouchTapRightIcon.bind(this, item)}
                  tooltip={this.context.getIntlMessage('invitation.remove')}
                  tooltipPosition="top-left"
                >
                  <ContentClear />
                </IconButton>
              }
              leftIcon={resendButton}
            />
          );
        })}

        {buttons}
      </List>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Invitation/InvitationOverview.js